import { render, staticRenderFns } from "./discordTech.vue?vue&type=template&id=47ed9394&scoped=true"
import script from "./discordTech.vue?vue&type=script&lang=js"
export * from "./discordTech.vue?vue&type=script&lang=js"
import style0 from "./discordTech.vue?vue&type=style&index=0&id=47ed9394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed9394",
  null
  
)

export default component.exports